//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "./stylus/index.styl";

export default {
  name: "App",
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {}
};



// WEBPACK FOOTER //
// ./src/App.vue